// extracted by mini-css-extract-plugin
export var container = "_4f-0";
export var icon = "_4f-1";
export var text = "_4f-2";